import { Link } from 'react-router-dom';
import React from 'react';
import HomeWorkProcess from './HomeWorkPorcess';
import './HomeAbout2.css';

export default function HomeAbout2() {
  return (
    <section
      id="about"
      className="about-us-area pt-155 pb-120 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30"
    >
      <div className="container">
        <div className="row">
          {/* -------- LEFT: COPY -------- */}
          <div className="col-lg-6">
            <div className="about-text-wrapper mb-30">
              <h2 className="style-text">SETUP</h2>
              <h2 className="sect-title">Two Ways to Get Started</h2>

              {/* Primary device setup */}
              <div className="quote-paragraph">
                <h3>1&nbsp;&nbsp;Standard Device Setup </h3>
                <br />
                <p className="paragraph-title">
                  All you need is a spare Android phone, a local SIM that sends SMS at a good rate,
                  and stable Wi-Fi. Install the TextLink gateway app, sign in, choose your outbound
                  country, plug the phone into a charger, and you’re live inside your dashboard.
                </p>
              </div>

              {/* GoHighLevel setup */}
              <div className="quote-paragraph">
                <h3>2&nbsp;&nbsp;GoHighLevel Quick-Connect</h3>
                <br />
                <p className="paragraph-title">
                  Using GHL as your CRM? Skip manual webhooks—install our official Conversation
                  Provider and map it to a gateway phone in under three minutes. Follow the guide&nbsp;
                  <Link style={{color:'blue', fontWeight:'bold'}} to="/ghl">here</Link>.
                </p>
              </div>

              {/* What you need */}
              <div className="quote-paragraph">
                <h3>What You Need</h3>
                <br />
                <p className="paragraph-title">
                  • Spare Android device&nbsp;&nbsp;• SIM with SMS bundle&nbsp;&nbsp;• Stable
                  internet. That’s it—no A2P filings, no carrier vetting.
                </p>
              </div>
            </div>
          </div>

          {/* -------- RIGHT: VIDEO -------- */}
          <div className="col-lg-6">
            <div className="about-video-wrapper mb-30">
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/koabZVvF8R0"
                  title="Setup overview"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
